module.exports = __webpack_public_path__ + "img/header-illustration@2x.c057eab9.png";